import { motion } from "framer-motion";

const STAGES = [
  { minLevel: 1, label: "Baby Scholar", emoji: "baby", color: "#FFD836" },
  { minLevel: 3, label: "Little Reader", emoji: "child", color: "#7DD3FC" },
  { minLevel: 5, label: "Bookworm", emoji: "teen", color: "#86EFAC" },
  { minLevel: 7, label: "Academic", emoji: "student", color: "#C4B5FD" },
  { minLevel: 9, label: "Distinguished Scholar", emoji: "scholar", color: "#FFD836" },
];

function getStage(level) {
  for (let i = STAGES.length - 1; i >= 0; i--) {
    if (level >= STAGES[i].minLevel) return { ...STAGES[i], index: i };
  }
  return { ...STAGES[0], index: 0 };
}

function BabySvg({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      {/* Body */}
      <ellipse cx="60" cy="75" rx="28" ry="24" fill="#FFE4B5" />
      {/* Head */}
      <circle cx="60" cy="42" r="28" fill="#FFE4B5" />
      {/* Cheeks */}
      <circle cx="45" cy="48" r="6" fill="#FFB6C1" opacity="0.5" />
      <circle cx="75" cy="48" r="6" fill="#FFB6C1" opacity="0.5" />
      {/* Eyes */}
      <circle cx="50" cy="40" r="4" fill="#1A1A1A" />
      <circle cx="70" cy="40" r="4" fill="#1A1A1A" />
      <circle cx="51.5" cy="38.5" r="1.5" fill="white" />
      <circle cx="71.5" cy="38.5" r="1.5" fill="white" />
      {/* Mouth */}
      <path d="M55 52 Q60 58 65 52" stroke="#1A1A1A" strokeWidth="2" fill="none" strokeLinecap="round" />
      {/* Tiny book */}
      <rect x="42" y="72" width="16" height="12" rx="2" fill="#7DD3FC" stroke="#1A1A1A" strokeWidth="1.5" />
      <line x1="50" y1="72" x2="50" y2="84" stroke="#1A1A1A" strokeWidth="1" />
      {/* Hair tuft */}
      <path d="M55 16 Q60 8 65 16" stroke="#8B6914" strokeWidth="3" fill="none" strokeLinecap="round" />
    </svg>
  );
}

function ChildSvg({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <ellipse cx="60" cy="80" rx="24" ry="20" fill="#7DD3FC" />
      <circle cx="60" cy="42" r="26" fill="#FFE4B5" />
      <circle cx="45" cy="48" r="5" fill="#FFB6C1" opacity="0.5" />
      <circle cx="75" cy="48" r="5" fill="#FFB6C1" opacity="0.5" />
      {/* Glasses */}
      <circle cx="50" cy="40" r="8" stroke="#1A1A1A" strokeWidth="2" fill="none" />
      <circle cx="70" cy="40" r="8" stroke="#1A1A1A" strokeWidth="2" fill="none" />
      <line x1="58" y1="40" x2="62" y2="40" stroke="#1A1A1A" strokeWidth="2" />
      {/* Eyes behind glasses */}
      <circle cx="50" cy="40" r="3" fill="#1A1A1A" />
      <circle cx="70" cy="40" r="3" fill="#1A1A1A" />
      <circle cx="51" cy="39" r="1" fill="white" />
      <circle cx="71" cy="39" r="1" fill="white" />
      <path d="M55 53 Q60 58 65 53" stroke="#1A1A1A" strokeWidth="2" fill="none" strokeLinecap="round" />
      {/* Book */}
      <rect x="36" y="74" width="20" height="14" rx="2" fill="#FFD836" stroke="#1A1A1A" strokeWidth="1.5" />
      <line x1="46" y1="74" x2="46" y2="88" stroke="#1A1A1A" strokeWidth="1" />
      {/* Hair */}
      <path d="M35 32 Q40 18 60 16 Q80 18 85 32" stroke="#6B4226" strokeWidth="4" fill="#6B4226" />
      {/* Backpack strap */}
      <path d="M42 65 L38 80" stroke="#FF6B6B" strokeWidth="3" strokeLinecap="round" />
      <path d="M78 65 L82 80" stroke="#FF6B6B" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

function TeenSvg({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <ellipse cx="60" cy="82" rx="22" ry="18" fill="#86EFAC" />
      <circle cx="60" cy="42" r="25" fill="#FFE4B5" />
      <circle cx="45" cy="48" r="4" fill="#FFB6C1" opacity="0.4" />
      <circle cx="75" cy="48" r="4" fill="#FFB6C1" opacity="0.4" />
      {/* Smart glasses */}
      <rect x="40" y="34" width="16" height="12" rx="3" stroke="#1A1A1A" strokeWidth="2" fill="none" />
      <rect x="64" y="34" width="16" height="12" rx="3" stroke="#1A1A1A" strokeWidth="2" fill="none" />
      <line x1="56" y1="40" x2="64" y2="40" stroke="#1A1A1A" strokeWidth="2" />
      <circle cx="48" cy="40" r="2.5" fill="#1A1A1A" />
      <circle cx="72" cy="40" r="2.5" fill="#1A1A1A" />
      <circle cx="49" cy="39" r="1" fill="white" />
      <circle cx="73" cy="39" r="1" fill="white" />
      <path d="M55 52 Q60 56 65 52" stroke="#1A1A1A" strokeWidth="2" fill="none" strokeLinecap="round" />
      {/* Stack of books */}
      <rect x="70" y="72" width="18" height="5" rx="1" fill="#FF6B6B" stroke="#1A1A1A" strokeWidth="1" />
      <rect x="68" y="67" width="18" height="5" rx="1" fill="#7DD3FC" stroke="#1A1A1A" strokeWidth="1" />
      <rect x="72" y="62" width="18" height="5" rx="1" fill="#FFD836" stroke="#1A1A1A" strokeWidth="1" />
      {/* Hair */}
      <path d="M36 35 Q40 16 60 14 Q80 16 84 35" fill="#4A3728" />
      {/* Pencil */}
      <line x1="34" y1="74" x2="28" y2="90" stroke="#FFD836" strokeWidth="3" strokeLinecap="round" />
      <line x1="28" y1="90" x2="27" y2="94" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function StudentSvg({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <ellipse cx="60" cy="82" rx="22" ry="18" fill="#C4B5FD" />
      <circle cx="60" cy="42" r="25" fill="#FFE4B5" />
      <circle cx="45" cy="48" r="4" fill="#FFB6C1" opacity="0.4" />
      <circle cx="75" cy="48" r="4" fill="#FFB6C1" opacity="0.4" />
      {/* Confident eyes */}
      <ellipse cx="50" cy="40" rx="3" ry="3.5" fill="#1A1A1A" />
      <ellipse cx="70" cy="40" rx="3" ry="3.5" fill="#1A1A1A" />
      <circle cx="51" cy="38.5" r="1.2" fill="white" />
      <circle cx="71" cy="38.5" r="1.2" fill="white" />
      {/* Determined smile */}
      <path d="M52 52 Q60 59 68 52" stroke="#1A1A1A" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      {/* Academic cap base */}
      <rect x="38" y="18" width="44" height="6" rx="1" fill="#1A1A1A" />
      {/* Cap top */}
      <polygon points="60,6 38,20 82,20" fill="#1A1A1A" />
      {/* Tassel */}
      <line x1="60" y1="6" x2="82" y2="12" stroke="#FFD836" strokeWidth="2" />
      <circle cx="84" cy="13" r="3" fill="#FFD836" />
      {/* Open book */}
      <path d="M40 74 Q50 70 60 74 Q70 70 80 74 L80 90 Q70 86 60 90 Q50 86 40 90 Z" fill="white" stroke="#1A1A1A" strokeWidth="1.5" />
      <line x1="60" y1="74" x2="60" y2="90" stroke="#1A1A1A" strokeWidth="1" />
      {/* Hair */}
      <path d="M36 28 Q40 18 60 16 Q80 18 84 28" fill="#2C1810" />
    </svg>
  );
}

function ScholarSvg({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      {/* Glow effect */}
      <circle cx="60" cy="55" r="55" fill="url(#scholarGlow)" opacity="0.3" />
      <defs>
        <radialGradient id="scholarGlow">
          <stop offset="0%" stopColor="#FFD836" />
          <stop offset="100%" stopColor="#FFD836" stopOpacity="0" />
        </radialGradient>
      </defs>
      {/* Robe */}
      <path d="M36 68 L30 105 L90 105 L84 68" fill="#1A1A1A" />
      <ellipse cx="60" cy="68" rx="24" ry="6" fill="#1A1A1A" />
      {/* Gold trim */}
      <path d="M36 68 L30 105" stroke="#FFD836" strokeWidth="2" />
      <path d="M84 68 L90 105" stroke="#FFD836" strokeWidth="2" />
      {/* Head */}
      <circle cx="60" cy="42" r="24" fill="#FFE4B5" />
      <circle cx="46" cy="46" r="3.5" fill="#FFB6C1" opacity="0.4" />
      <circle cx="74" cy="46" r="3.5" fill="#FFB6C1" opacity="0.4" />
      {/* Wise eyes */}
      <ellipse cx="50" cy="40" rx="3" ry="2" fill="#1A1A1A" />
      <ellipse cx="70" cy="40" rx="3" ry="2" fill="#1A1A1A" />
      <circle cx="51" cy="39.5" r="1" fill="white" />
      <circle cx="71" cy="39.5" r="1" fill="white" />
      {/* Wise smile */}
      <path d="M52 50 Q60 56 68 50" stroke="#1A1A1A" strokeWidth="2" fill="none" strokeLinecap="round" />
      {/* Graduation cap */}
      <rect x="36" y="20" width="48" height="6" rx="1" fill="#1A1A1A" />
      <polygon points="60,6 34,22 86,22" fill="#1A1A1A" />
      <line x1="60" y1="6" x2="86" y2="14" stroke="#FFD836" strokeWidth="2.5" />
      <circle cx="88" cy="15" r="4" fill="#FFD836" />
      {/* Diploma scroll */}
      <rect x="72" y="74" width="14" height="20" rx="3" fill="#FFF5DC" stroke="#FFD836" strokeWidth="1.5" />
      <line x1="76" y1="80" x2="82" y2="80" stroke="#C4B5FD" strokeWidth="1" />
      <line x1="76" y1="84" x2="82" y2="84" stroke="#C4B5FD" strokeWidth="1" />
      {/* Stars */}
      <circle cx="24" cy="20" r="2" fill="#FFD836" opacity="0.8" />
      <circle cx="96" cy="28" r="1.5" fill="#FFD836" opacity="0.6" />
      <circle cx="18" cy="50" r="1.5" fill="#FFD836" opacity="0.7" />
      <circle cx="102" cy="50" r="2" fill="#FFD836" opacity="0.5" />
      {/* Hair */}
      <path d="M37 28 Q42 18 60 16 Q78 18 83 28" fill="#555" />
    </svg>
  );
}

const SVG_MAP = [BabySvg, ChildSvg, TeenSvg, StudentSvg, ScholarSvg];

export default function ScholarAvatar({ level = 1, size = 120, showLabel = true }) {
  const stage = getStage(level);
  const SvgComponent = SVG_MAP[stage.index];
  const progressToNext = stage.index < STAGES.length - 1
    ? ((level - stage.minLevel) / (STAGES[stage.index + 1]?.minLevel - stage.minLevel)) * 100
    : 100;

  return (
    <div className="flex flex-col items-center" data-testid="scholar-avatar">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 200, damping: 15 }}
        className="relative"
      >
        {/* Bouncing animation */}
        <motion.div
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        >
          <SvgComponent size={size} />
        </motion.div>

        {/* Level badge */}
        <div
          className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full border-2 border-neo-border dark:border-[#444] shadow-[2px_2px_0px_0px_#1A1A1A] flex items-center justify-center font-heading font-extrabold text-xs"
          style={{ backgroundColor: stage.color }}
        >
          {level}
        </div>
      </motion.div>

      {showLabel && (
        <div className="text-center mt-2">
          <p className="font-heading font-bold text-sm dark:text-white">{stage.label}</p>
          {stage.index < STAGES.length - 1 && (
            <div className="mt-1 w-24">
              <div className="h-1.5 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden">
                <motion.div
                  className="h-full rounded-full"
                  style={{ backgroundColor: stage.color }}
                  initial={{ width: 0 }}
                  animate={{ width: `${progressToNext}%` }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                />
              </div>
              <p className="text-[10px] text-neo-text-secondary dark:text-gray-500 mt-0.5">
                Lv {STAGES[stage.index + 1]?.minLevel} to evolve
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
